<ng-container *ngIf="!isLoading && !isServerError">
  <div class="card-header-mini mb-0" >
    <h3 class="card-title">{{title}}</h3>
    <a [href]="leftLinkUrl" target="{{leftLinkTarget}}" class="more-link">{{leftLinkText}}</a>
  </div>

  <ng-container *ngIf="accountData.length">
    <div class="phone-account-info d-not-phone-none">
      <ng-container *ngFor="let item of accountData">
        <ng-container *ngIf="displayedTypesOnMobile.includes(item.type)">
          <div class="info-col">
            <div class="info-value">
              <span *ngIf="item.balance; else emptyFieldText" 
                  [ngClass]="item.isInFavourBalance != null ? (item.isInFavourBalance ? 'inFavour' : 'inDebt') : ''">
                <span class="count" dir="ltr">{{item.balance}}</span> {{currencyName}}
              </span>
            </div>
            <div class="info-label">
              <span>{{item.description || getRowTypeName(item.type).title}}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <mat-table [dataSource]="accountData" class="d-phone-none">
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          <div>
            <div class="d-flex align-items-center">
              {{ getRowTypeName(element.type).title }}
              <span class="question-icon" [matTooltip]="getRowTypeName(element.type).description">?</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="balance">
        <mat-cell *matCellDef="let element" class="balance-td">   
          <span *ngIf="element.balance; else emptyFieldText">
            <span *ngIf="element.isInFavourBalance != null"
              [ngClass]="element.type == BillingTableRowType.CurrentBalance ? (element.isInFavourBalance ? 'inFavour inline' : 'inDebt inline') : ''">
              {{ convertBalanceValue(element.balance) }} {{currencyName}}
              <span *ngIf="element.type == BillingTableRowType.CurrentBalance"
                [ngClass]="element.type == BillingTableRowType.CurrentBalance ? (element.isInFavourBalance ? 'inFavour inline' : 'inDebt inline') : ''">
                {{element.isInFavourBalance && element.type== BillingTableRowType.CurrentBalance ? element.inFavourText :
                element.inDebtText}}</span>
            </span>
            <span *ngIf="element.isInFavourBalance == null">{{ convertBalanceValue(element.balance) }} {{currencyName}}</span>
          </span>
      
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-cell *matCellDef="let element" class="description-td">
          <span *ngIf="element.description">{{ element.description }}</span>
          <span *ngIf="!element.description && element.type != BillingTableRowType.CurrentBalance" [ngTemplateOutlet]="emptyFieldText"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-cell *matCellDef="let element" class="date-td">
          <div *ngIf="element.type === BillingTableRowType.NextVoucher">
            <span *ngIf="element.date; else emptyFieldText">
              <div><strong>{{ element.date }}</strong></div>
            </span>
          </div>

          <div *ngIf="element.type === BillingTableRowType.LastPaymentMade">
            <span *ngIf="element.date; else emptyFieldText">
              <div class="d-flex align-items-center lastPaymentMadeDate-text">
                <mat-icon [svgIcon]="'check'" class="square-icon check-icon"></mat-icon>
                <span>{{ element.date }} <span></span></span>
              </div>
            </span>
          </div>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <p class="d-phone-none table-description">{{footnoteText}}</p>
  </ng-container>

  <div *ngIf="!accountData.length">{{noResultsMessage}}</div>
</ng-container>

<ng-container *ngIf="isLoading && !isServerError">
  <div class="card-header-mini mb-0" >
    <h3 class="card-title">{{title}}</h3>
    <a [href]="leftLinkUrl" target="{{leftLinkTarget}}" class="more-link">{{leftLinkText}}</a>
  </div>

  <ng-container *ngIf="accountData.length">
    <div class="phone-account-info d-not-phone-none">
      <ng-container *ngFor="let item of displayedTypesOnMobile">
        <div class="info-col">
          <div class="info-value">
            <app-skeleton [type]="'text'" class="more-link" [symbolsCount]="8"/>
          </div>
          <div class="info-label">
            <app-skeleton [type]="'text'" [symbolsCount]="10"/>
          </div>
        </div>
      </ng-container>
    </div>

    <mat-table [dataSource]="accountData" class="d-phone-none">
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          <app-skeleton [type]="'text'" [symbolsCount]="10"/>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="balance">
        <mat-cell *matCellDef="let element" class="balance-td">   
          <app-skeleton [type]="'text'" [symbolsCount]="10"/>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-cell *matCellDef="let element" class="description-td">
          <app-skeleton [type]="'text'" [symbolsCount]="18"/>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-cell *matCellDef="let element" class="date-td">
          <app-skeleton [type]="'text'" [symbolsCount]="18"/>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <p class="d-phone-none table-description">{{footnoteText}}</p>
  </ng-container>

  <div *ngIf="!accountData.length">{{noResultsMessage}}</div>
</ng-container>

<ng-template #emptyFieldText>
  <span><strong>-</strong></span>
</ng-template>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>